import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[notwhitespace]'
})
export class NotWhitespaceDirective {

  constructor(private elem: ElementRef) {
    //
  }

  @HostListener('keyup')
  onKeyPress() {
    const reg = / +/g;
    const value = this.elem.nativeElement.value;
    this.elem.nativeElement.value = value.trim().replace(reg, ' ');
  }

}
